export default {"src":"/login-app/[GIT_HASH]/_next/static/media/toggle_whitespace.1f50ddce.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};